// src/pages/Dashboard.js
import React, { useState } from 'react';
import { useAuth } from '../components/AuthContext';
import Hero from '../components/Hero';
import SubscriptionSection from '../components/SubscriptionSection';
import './Dashboard.css';



// import SubscriptionSection from "../components/SubscriptionSection";

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('reports'); // 'reports' | 'account'


  const handleLogout = () => {
    logout();
  };

  return (
    <div className="dashboard-container">
      {/* Hero-style Header */}
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <div className="logo">
              <span className="logo-text">JobFAX</span>
            </div>
            <nav className="nav-menu">
              <button
                type="button"
                className={`nav-item ${activeTab === 'reports' ? 'active' : ''}`}
                onClick={() => setActiveTab('reports')}
              >
                Reports
              </button>

              <button
                type="button"
                className={`nav-item ${activeTab === 'account' ? 'active' : ''}`}
                onClick={() => setActiveTab('account')}
              >
                Account
              </button>
            </nav>

          </div>
          
          <div className="header-right">
            <div className="user-info">
              <span className="welcome-text">Welcome, {user?.firstName || user?.email}!</span>
              <div className="user-dropdown">
                <button className="user-button">
                  {user?.firstName?.charAt(0) || user?.email?.charAt(0) || 'U'}
                </button>
                <div className="dropdown-menu">
                  <a href="#" className="dropdown-item">Profile</a>
                  <a href="/search-history" className="dropdown-item">Search History</a>
                  <a href="#" className="dropdown-item">Settings</a>
                  <hr className="dropdown-divider" />
                  <button onClick={handleLogout} className="dropdown-item logout-item">
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Dashboard Content */}
      <div className="dashboard-content">
        {activeTab === 'reports' ? (
          <Hero />
        ) : (
          <div className="account-wrap">
            <div className="account-header">
              <h2>Account</h2>
              <p>Manage your subscription and billing.</p>
            </div>
            <SubscriptionSection />
          </div>
        )}
      </div>

    </div>
  );
};

export default Dashboard;